import { summaryBarContent } from './types';
import { CLASS_ACTIVE } from '../tools/constants/classes';

const getMarkup = (data:summaryBarContent) => {
  const template = document.createElement('template');

  template.innerHTML = `
    <style>
      :host {
        min-height: 3.75rem;
        position: fixed;
        left: 1.25rem;
        bottom: 1.25rem;
        right: 1.25rem;
        display: flex;
        align-items: center;
        z-index: 1;
        width: -webkit-fill-available;
        transition: all 1.4s cubic-bezier(.16,1,.3,1);
        width: auto;
      }

      :host(.summary-in-view) {
        transform: translateY(140%);
        opacity: 0;
      }

      .summary-bar {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 2.5rem);
        align-items: center;
        cursor: pointer;
        background: #FCFCFB;
        padding: 1rem 1.5rem;
        border-radius: 1rem;
        transition: background 1.4s cubic-bezier(0.16, 1, 0.3, 1);
        flex-wrap: wrap;
        box-shadow: 0 0 .625rem #F5F2F0;
      }

      .text-wrapper {
        display: flex;
        gap: .625rem;
        margin-right: 1.5rem;
      }

      .title, .price {
        color: #163021;
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.5rem;
        letter-spacing: .02rem;
        margin: 0;
      }

      .price {
        color: #3F7355;
      }

      .toggle {
        display: flex;
        gap: .5rem;
        align-items: center;
        color: #7C8D80;
        font-size: .8125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.25rem;
      }

      .toggle p {
        margin: 0;
      }

      svg {
        width: .5rem;
        height: .5rem;
      }

      .summary-content {
        width: 100%;
        max-height: 0;
        overflow: hidden;
        transition: max-height 1.4s cubic-bezier(0.16, 1, 0.3, 1);
      }

      .summary-bar.is-active .summary-content {
        max-height: 12.5rem;
      }

      .title {
        margin-top: .75rem;
      }

      .title.is-desktop {
        display: none;
      }
      
      .summary-content__inner {
        display: flex;
        flex-wrap: wrap;
        gap: .125rem .375rem;
        color: #163021;
        font-size: .8125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.25rem;
      }

      .separator {
        opacity: 30%;
      }
      
      .price-wrapper .summary-title,
      .price-wrapper .title {
        display: none;
      }

      @media only screen and (min-width: 1100px) {
        :host {
          background: transparent;
          margin: 0;
          padding: 0;
          bottom: 2.5rem;
          left: auto;
          width: 27.75rem;
          right: 2.5rem;
          transition: all 500ms;
        }

        .toggle {
          font-size: .875rem;
        }

        .price-wrapper {
          display: flex;
          gap: .5rem;

          margin: 0;
          font-family: Recoleta, sans-serif;
          font-weight: 500;
          letter-spacing: 0;
          font-size: 1.5rem;
          line-height: 2rem;
        }
          
        .price-wrapper .price,
        .price-wrapper .summary-title {
          font-size: inherit;
          font-family: inherit;
          font-weight: inherit;
          letter-spacing: inherit;
          line-height: inherit;
        }

        .title.is-mobile {
          display: none;
        }

        .price-wrapper .summary-title,
        .title.is-desktop {
          display: block;
          margin: 0 0 .5rem;
        }

        .text-wrapper {
          flex-direction: column;
          gap: 0;
          margin: 0;
        }

        .summary-bar {
          background: #F5F2F0;
          border: 4px solid #fcfcfb;
          box-shadow: none;
          padding: 1.5rem;
          border-radius: 1rem;
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: calc(100% - 3.5rem);
        }

        .summary-bar:hover {
          background: #F1EBE7;
        }

        .summary-content__inner {
          font-size: .875rem;
          margin-top: .75rem;
        }
      }

      @media only screen and (min-width: 1750px) {
        :host {
          right: 3rem;
          width: 38.5rem;
          bottom: 3rem;
        }

        .toggle {
          font-size: 1.125rem;
          line-height: 1.5rem;
        }

        .title, .price {
          font-size: 1.125rem;
          line-height: 1.5rem;
        }

        .summary-bar {
          padding: 1.5rem 2.25rem;
          border-radius: 1.75rem;
          width: calc(100% - 4.875rem);
        }

        .summary-content__inner {
          font-size: 1.125rem;
          line-height: 1.5rem;
        }
      }
    </style>

    <div class="summary-bar" part="root">
      <div class="text-wrapper">

        <div class="price-wrapper">
          <h3 class="summary-title">Subtotal</h3>
          <p class="price"></p>
          
        </div>
        <p class="title is-desktop">${data.title}</p>
        
      </div>
      <div class="toggle">
        <p>Customisation Summary</p>
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8"><path d="M1.5 5 4 2.5 6.5 5" stroke="#7C8D80" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div class="summary-content">
        <p class="title is-mobile">${data.title}</p>
        <div class="summary-content__inner"></div>
      </div>
    </div>
  `;
  
  return template;
}

export class CustomiserSummaryBar extends HTMLElement {
  private data: summaryBarContent;
  private button: HTMLButtonElement | null | undefined = null;
  private priceEl:HTMLElement|null|undefined;

  constructor() {
    super();

    const data = this.getAttribute('data');

    if (!data) {
      console.error('Need to supply some data for this option!', this);
      return;
    }

    this.data = JSON.parse(data)!;
    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = getMarkup(this.data);
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.button = this.shadowRoot?.querySelector('.summary-bar');
    this.button?.addEventListener('click', () => {
      this.button?.classList.toggle(CLASS_ACTIVE);
    });

    this.priceEl = this.shadowRoot?.querySelector('.price');
  }

  public updateSummaryBar(price, data: any) {
    const summaryContainer = this.shadowRoot?.querySelector('.summary-content__inner');
    this.priceEl.textContent = `$${price}`;
    if (!summaryContainer) return;

    // Clear existing summary items
    summaryContainer.innerHTML = '';

    data.forEach((section, index) => {
      if (!section.value) return;

      let dataTitle = section.value;

      if (section.title == 'Colour') {
        const colorNameSplit = section.value.split('-');
        dataTitle = colorNameSplit[colorNameSplit.length - 1].trim();
      }

      const summaryItem = `<span>${dataTitle}</span>`;
      summaryContainer.innerHTML += summaryItem;

      if (index < data.length - 1) {
        const separator = `<span class="separator"> / </span>`;
        summaryContainer.innerHTML += separator;
      }
    });
  }
}

if (!customElements.get('customiser-summary-bar')) {
  customElements.define('customiser-summary-bar', CustomiserSummaryBar);
}